// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.brew_sensory_category */
var BrewSensoryCategory;
(function (BrewSensoryCategory) {
    BrewSensoryCategory["aroma"] = "aroma";
    BrewSensoryCategory["taste"] = "taste";
})(BrewSensoryCategory || (BrewSensoryCategory = {}));
;
export default BrewSensoryCategory;
/** Zod schema for brew_sensory_category */
export const brewSensoryCategory = z.nativeEnum(BrewSensoryCategory);
//# sourceMappingURL=BrewSensoryCategory.js.map